/* unplugin-vue-components disabled */import { render } from "./ToolboxOverlay.vue?vue&type=template&id=68ef92e2&scoped=true&ts=true"
import script from "./ToolboxOverlay.vue?vue&type=script&lang=ts"
export * from "./ToolboxOverlay.vue?vue&type=script&lang=ts"

import "./ToolboxOverlay.vue?vue&type=style&index=0&id=68ef92e2&lang=scss&scoped=true"

import exportComponent from "/Users/rathasitjearnpasawarn/var/apps/myculture/runner/assessment-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ef92e2"]])

export default __exports__